import dayjs, { Dayjs } from 'dayjs';

/**
 * Checks if a given date is a weekend (Saturday or Sunday).
 * @param date - The date to check (Dayjs object).
 * @returns true if Saturday or Sunday, false otherwise.
 */
export const isWeekend = (date: Dayjs): boolean => {
  const day = date.day();
  return day === 0 || day === 6; // 0 is Sunday, 6 is Saturday
};

/**
 * Checks if a given date is in the past (before today).
 * @param date - The date to check (Dayjs object).
 * @returns true if before today, false otherwise.
 */
export const isPastDate = (date: Dayjs): boolean => {
  return date.isBefore(dayjs(), 'day');
};

/**
 * Disabled Date function for Ant Design DatePicker.
 * Disables weekends (Saturday/Sunday) AND past dates.
 */
export const disabledDateWeekend = (current: Dayjs): boolean => {
  if (!current) return false;
  // Disable weekends AND past dates
  return isWeekend(current) || isPastDate(current);
};
